<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ entity.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <EntityTabLinks />
                    <CRow class="pl-3 pb-3" />
                    <CRow class="pl-3 pb-3">
                        <CButton color="primary" @click="addCategory">Добавить</CButton>
                    </CRow>
                    <CRow class="pl-3">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Название</th>
                                    <th>В корзину</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <draggable v-model="categories" tag="tbody">
                                <tr v-for="category in categories" :key="category.id">
                                    <td>
                                        <CIcon
                                            :height="24"
                                            :content="$options.icons.cilCursorMove"
                                            class="handle" />
                                    </td>
                                    <td>{{ category.title }}</td>
                                    <td>{{ category.cart_button_title || '—' }}</td>
                                    <td style="text-align: right">
                                        <CButton @click="editCategory(category)">
                                            <CIcon :content="$options.icons.cilPencil" class="handle" />
                                        </CButton>
                                        <CButton @click="removeCategory(category)">
                                            <CIcon :content="$options.icons.cilTrash" class="handle" />
                                        </CButton>
                                    </td>
                                </tr>
                            </draggable>
                        </table>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="info"
                        class="mr-3"
                        @click="save">Сохранить порядок</CButton>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack">Отмена</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

        <EntityCategoryUpsertDialog
            ref="upsertDialog"
            :entity="selectedCategory"
            :categories="categories"
            @success="fetch" />

        <AppConfirmDialog
            ref="confirmDialog"
            title="Подтверждение"
            color="danger"
            text="Вы действительно хотите удалить категорию? Это действие нельзя будет отменить."
            @confirm="confirmDelete" />
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import to from 'await-to-js';
    import draggable from 'vuedraggable';
    import { cilCursorMove, cilTrash, cilPencil } from '@coreui/icons';

    import EntityTabLinks from '@/components/entities/EntityTabLinks';
    import EntityCategoryUpsertDialog from '@/components/entities/EntityCategoryUpsertDialog';
    import AppConfirmDialog from '@/components/AppConfirmDialog';

    export default {
        name: 'EntityCategories',

        components: {
            EntityTabLinks,
            draggable,
            EntityCategoryUpsertDialog,
            AppConfirmDialog,
        },

        icons: {
            cilCursorMove,
            cilTrash,
            cilPencil,
        },

        data() {
            return {
                entity: {
                    title: '',
                },
                categories: [],
                selectedCategory: {},
            };
        },

        computed: {},

        async created() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const id = parseInt(this.$route.params.id);
                const code = this.$route.params.code;
                Vue.axios
                    .get(`/entities/get/${id}`)
                    .then(resp => {
                        this.entity = resp.data;
                    })
                    .catch(() => {
                        this.$root.$emit('showError', 'Ошибка загрузки данных.');
                    });
                Vue.axios
                    .get(`/entities/${code}/get-categories/${id}`)
                    .then(resp => {
                        this.categories = resp.data.map(item => {
                            item.enabled = Boolean(item.enabled);
                            item.empty = Boolean(item.empty);
                            return item;
                        });
                    })
                    .catch(() => {
                        this.$root.$emit('showError', 'Ошибка загрузки данных.');
                    });
            },

            save() {
                const id = parseInt(this.$route.params.id);
                const code = this.$route.params.code;
                const categoriesToSave = [];
                let index = 0;
                this.categories.forEach(category => {
                    categoriesToSave.push({
                        id: category.id,
                        position: ++index,
                    });
                });
                Vue.axios
                    .post(`/entities/${code}/reorder-categories/${id}`, {
                        reorder: categoriesToSave,
                    })
                    .then(() => {
                        this.goBack();
                    })
                    .catch(() => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },

            addCategory() {
                this.selectedCategory = {
                    entity_id: this.entity.id,
                };
                this.$refs.upsertDialog.open();
            },

            editCategory(category) {
                this.selectedCategory = category;
                this.$refs.upsertDialog.open();
            },

            removeCategory(category) {
                this.selectedCategory = category;
                this.$refs.confirmDialog.open();
            },

            async confirmDelete() {
                if (!this.selectedCategory.id) {
                    return false;
                }

                const [error] = await to(
                    this.axios.delete(
                        `/entities/${this.$route.params.code}/delete-categories/${this.$route.params.id}/${this.selectedCategory.id}`
                    )
                );

                if (error) {
                    return this.$root.$emit('showError', 'ошибка при удалении категории. ' + error);
                }

                await this.fetch();
            },

            goBack() {
                this.$router.push({
                    path: `/entities/${this.$route.params.code}/${this.$route.params.id}`,
                });
            },
        },
    };
</script>
<style scoped>
.handle {
    cursor: pointer;
}
</style>
